import { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';

import { PublisherApi, SessionApi } from "../ApiUrl"
import dataFetcher from "../dataFetcher"
import { PublisherInfoHook } from "./PublisherInfoHook";
import { useIdleTimer } from "react-idle-timer";


const DEFAULT_TIMEOUT = 1000 * 60 * 15;

export const SessionPageHook = () => {
    const [sessionKey, setSessionKey] = useState('false');
    const [logoutModal, setLogoutModal] = useState(false);
    const [sessionTimeoutModal, setSessionTimeoutModal] = useState(false);
    const [timeoutLogout, setTimeoutLogout] = useState(false);
    const { state: publisherState, actions: publisherActions } = PublisherInfoHook();
    const appHistory = useHistory()

    const logoutConfirmation = () => {
        setLogoutModal(!logoutModal);
    }

    const SetSessionInfo = () => {
        if (sessionStorage.getItem('sk')) setSessionKey(sessionStorage.getItem('sk'));
        publisherActions.setPublisherInfoFromStorage()
    }

    const handleSessionTimeoutModal = () => {
        setSessionTimeoutModal(true);
    }

    const checkSession = async () => {
        try {
            var res = await dataFetcher({
                apiUrl: PublisherApi.getChecksessionUrl(),
                fetchMethod: 'POST',
            });
            if (res.Status === 'OK') {
                publisherActions.setPublisherID(res.Publisher_ID)
                SetSessionInfo();
            } else {
                if (sessionKey === 'true') {
                    sessionStorage['sk'] = false;
                    sessionStorage.removeItem('mk');
                    sessionStorage.removeItem('pk');
                    sessionStorage.removeItem('uenk');
                    sessionStorage.removeItem('pnk');
                    sessionStorage.removeItem('unk');
                    sessionStorage.removeItem('tk');
                    sessionStorage.removeItem('suk');
                    sessionStorage.removeItem('ISNSearch');
                    sessionStorage.removeItem('DepositSearch');
                    sessionStorage.removeItem('CIPSearch');
                    handleSessionTimeoutModal();
                }
            }
        } catch (error) {
            console.error(error)
        }
    }

    const logoutSession = async (getBool) => {
        try {
            var res = await dataFetcher({
                apiUrl: SessionApi.getLogoutUrl(),
                fetchMethod: 'POST',
            });
            if (res.Status === 'OK') {
                sessionStorage['sk'] = false;
                sessionStorage.removeItem('mk');
                sessionStorage.removeItem('pk');
                sessionStorage.removeItem('uenk');
                sessionStorage.removeItem('pnk');
                sessionStorage.removeItem('unk');
                sessionStorage.removeItem('tk');
                sessionStorage.removeItem('suk');
                sessionStorage.removeItem('ISNSearch');
                sessionStorage.removeItem('DepositSearch');
                sessionStorage.removeItem('CIPSearch');
                setSessionKey(false);
                setTimeout(() => {
                    appHistory.push('/');
                    logoutModal && setLogoutModal(false);
                }, 200);
            }
        } catch (error) {
            console.error(error);
        }
    }


    const handleOnIdle = async (event) => {
        if (sessionStorage['sk'] === 'true' || sessionStorage['sk'] === true) {
            setTimeoutLogout(true);
            await logoutSession();
        }
    }

    const { getRemainingTime, isPrompted, activate } = useIdleTimer({
        timeout: DEFAULT_TIMEOUT,
        debounce: 250,
        onIdle: handleOnIdle
    })

    useEffect(() => {
        const unlisten = appHistory.listen((location) => {
            //SetSessionInfo();
            checkSession();
        });
        return function cleanup() {
            unlisten();
        }
    }, []);

    return {
        state: { logoutModal, sessionKey, sessionTimeoutModal, timeoutLogout, publisherState },
        actions: { SetSessionInfo, logoutConfirmation, handleSessionTimeoutModal, checkSession, logoutSession }
    }
}

